import Swiper from 'swiper/bundle'

const sliderSwiper = () => {
  const settings = {
    grabCursor: true,
    speed: 1000,
    autoplay: {
      delay: 3500
    },
    pagination: {
      el: '.swiper-pagination'
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev'
    }
  }

  const sliders = [...document.querySelectorAll('.js-hero-slider')]
  /* eslint-disable */
  sliders.map((slider) => {
    const swiperInstance = new Swiper(slider, settings)

    let isManualChange = false

    swiperInstance.on('slideChange', () => {
      if (isManualChange) {
        const previousIndex = swiperInstance.previousIndex
        const currentIndex = swiperInstance.activeIndex
        const direction = currentIndex > previousIndex ? 'right' : 'left'

        window.dataLayer.push({
          event: 'heroBlockSliderScroll',
          direction: direction,
          textVisualBlockTitle: slider.querySelector('.swiper-slide-active h2')?.innerText.trim()
        })
        isManualChange = false
      }
    })

    swiperInstance.on('touchStart', () => {
      isManualChange = true
    })

    swiperInstance.on('transitionEnd', () => {
      isManualChange = false
    })
  })
  /* eslint-enable */
}

export default sliderSwiper
